<template>
  <div class="bg">
    <v-app id="inspire">
      <v-content>
        <v-dialog
          :value="dialog"
          scrollable
          persistent
          width="800px"
          fullscreen
        >
          <v-card>
            <!-- <v-toolbar color="primary" flat card>
              <v-flex xs12 py-2 text-xs-center>
                <img class="logo" src="@/assets/images/logo-white.png" />
              </v-flex>
            </v-toolbar>
            <v-toolbar color="primary" flat dense card dark>
              <v-toolbar-title>{{$t('titles.global.termsOfUse', locale).toUpperCase()}}</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider> -->

            <v-card-text>
              <v-container>
                <div v-html="$t('terms.termsOfUse.content', locale)" />
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-content>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'TermsAndConditions',
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    locale() {
      const locales = ['es', 'ca', 'en']

      if (
        this.$route.params.locale &&
        locales.includes(this.$route.params.locale)
      )
        return this.$route.params.locale
      else return 'es'
    },
  },
  mounted() {
    this.dialog = true
  },
}
</script>
<style>
.logo {
  margin: auto;
  max-width: 200px;
}
.bg {
  background-image: url('/background.png');
  background-size: cover;
  background-color: #00482b;
}
#inspire {
  background: none;
}
</style>
